import axios from 'axios';

const OrganizationsAPI = {
  /**
   * Get organization details by ID
   * @param {number} organizationId - Organization ID
   * @returns {Promise}
   */
  getOrganization(organizationId) {
    return axios.get(`/organizations/${organizationId}`);
  },

  /**
   * Get multiple organizations by IDs
   * @param {Array} organizationIds - Array of organization IDs
   * @returns {Promise}
   */
  getOrganizations(organizationIds) {
    return axios.get('/organizations', {
      params: {
        ids: organizationIds,
      },
    });
  },

  /**
   * Get multiple organizations by IDs (comma-separated string format)
   * @param {Array} organizationIds - Array of organization IDs
   * @returns {Promise}
   */
  getOrganizationsByString(organizationIds) {
    return axios.get('/organizations', {
      params: {
        ids: organizationIds.join(','),
      },
    });
  },
};

export default OrganizationsAPI;
